import React, {
  useState,
  useCallback,
  useRef,
  useEffect,
  useImperativeHandle
} from "react";

//api //add ons
import { GoogleMap, useLoadScript, Marker } from "@react-google-maps/api";
import * as locationData from "../../data/data.json";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import $ from "jquery";

//components
import Locate from "./Locate.js";
import SearchField from "../search/SearchField.js";
import MapMarker from "./MapMarker.js";

//assets
import zoomIn from "../../assets/images/icons/zoom-in.svg";
import zoomOut from "../../assets/images/icons/zoom-out.svg";
import mapPinCurrent from "../../assets/images/map-pin-current.svg";

const BlueToolTip = withStyles(theme => ({
  tooltip: {
    backgroundColor: "#0016C7;",
    fontFamily: "Work Sans, sans",
    fontWeight: 600,
    fontSize: 12,
    letterSpacing: 0.5,
    padding: 10
  }
}))(Tooltip);

const Map = props => {
  const {
    setMapRef,
    searchRef,
    passVisibleMarkers,
    passNationalMarkers,
    passMarkerData,
    setPlaces,
    updateCurrentView,
    currentLocation,
    updateCurrentLocation,
    setSelectedMarker,
    currentView,
    togglePinsOff,
    mobileView,
    selectedResult,
    currentSearchValue
  } = props;
  const mapRef = useRef();
  // const pinStateRef = useRef();
  const [mapZoom, setMapZoom] = useState(10);
  const [mapCenter, setMapCenter] = useState({
    lat: 39.1159298,
    lng: -94.6207443
  });
  const [markerMap, setMarkerMap] = useState([]);
  const [initLoad, setInitLoad] = useState(true);
  const [visibleMarkers, setVisibleMarkers] = useState([]);
  const [nationalMarkers, setNationalMarkers] = useState([]);
  const [mobileFullView, setMobileFullView] = useState(false);
  const [libraries] = useState(["places"]);
  const dataLength = locationData.locations.length;

  //google maps options
  const options = {
    disableDefaultUI: true,
    zoomControl: true,
    zoomControlOptions: {
      position: "right: -100px;"
    }
  };

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries
  });

  const resizeObserver = new ResizeObserver(() => {
    let height = $("#root").height();
    //console.log(height);
    window.parent.postMessage({ height: height }, "*");
  });

  //get current reference to map once it loads
  const onMapLoad = useCallback(map => {
    mapRef.current = map;
    setMapRef(map);
  }, []);

  const getCurrentLocation = () => {
    navigator.geolocation.getCurrentPosition(
      position => {
        updateCurrentLocation({
          lat: position.coords.latitude,
          lng: position.coords.longitude
        });
        mapRef.current.panTo({
          lat: position.coords.latitude,
          lng: position.coords.longitude
        });
        mapRef.current.setZoom(10);

        //getViewableMarkers();
      },
      () => null
    );
  };

  // create a mapping of our locations to actual Marker objects
  // this is our working data set for React
  var mapLoadArray = [];
  var dataLoaded = 0;
  const markerLoadHandler = useCallback(
    (marker, location) => {
      if (initLoad) {
        mapLoadArray.push([marker, location]);
        dataLoaded++;
        if (dataLoaded === dataLength) {
          setMarkerMap(mapLoadArray);
        }
      }
    },
    [markerMap]
  );

  useImperativeHandle(searchRef, () => ({
    getViewableMarkers() {
      //("getViewableMarkers");
      let currentBounds = mapRef.current.getBounds();

      //////////
      //VISIBLE LOCATIONS ARRAY
      setVisibleMarkers([]);
      var visibleMarkersArray = [];
      var visibleMarkersLoaded = 0;

      //add current viewable markers
      markerMap.map(marker => {
        if (currentBounds.contains(marker[0].getPosition()) === true) {
          //check if statewide so it will not repeat in statewide array
          if (marker[1].StateWide !== true) {
            visibleMarkersArray.push([marker[0], marker[1]]);
          }
        }
        visibleMarkersLoaded++;
        if (visibleMarkersLoaded === dataLength) {
          setVisibleMarkers(visibleMarkersArray);
        }
      }, []);
      ////////////////////////////

      //////get id's of visible items to check for repeats
      var currentVisibleMarkersIDs = [];
      visibleMarkersArray.map(marker => {
        currentVisibleMarkersIDs.push(marker[1].ID);
      });

      /////////
      //NATIONAL LOCATIONS ARRAY
      setNationalMarkers([]);
      var nationalMarkersArray = [];

      markerMap.map(marker => {
        if (marker[1].Type === "National") {
          nationalMarkersArray.push([marker[0], marker[1]]);
        }
      }, []);
      /////////////////////

      //filter repeats for National locations
      var noRepeatsNationalMarkersArray = [];
      noRepeatsNationalMarkersArray = nationalMarkersArray.filter(item => {
        return currentVisibleMarkersIDs.indexOf(item[1].ID) == -1;
      });

      setNationalMarkers(noRepeatsNationalMarkersArray);
    }
  }));

  const markerClickHandler = (marker, location) => {
    mapRef.current.panTo({
      lat: location.Latitude,
      lng: location.Longitude
    });
    let currentZoom = mapRef.current.getZoom();

    if (currentZoom < 10) {
      setMapZoom(10);
    }
    if (currentZoom >= 10) {
      setMapZoom(currentZoom + 1);
    }
    //true == map click
    setSelectedMarker(location.ID, true);
  };

  const handleSearchSubmit = value => {
    currentSearchValue(value);

    setSelectedMarker(0, false);

    if (currentView.initialView === true) {
      if (mobileView) {
        updateCurrentView("expandView");
        setMobileFullView(true);
        window.parent.postMessage({ mobileFullView: "true" }, "*");
      } else {
        updateCurrentView("searchView");
      }
    }

    //delay call so map view has time to update
    setTimeout(function() {
      getViewableMarkers();
    }, 100);
  };

  const handleZoomOut = () => {
    let zoom = mapRef.current.zoom + 1;
    setMapZoom(zoom);
  };

  const handleZoomIn = () => {
    let zoom = mapRef.current.zoom - 1;
    setMapZoom(zoom);
  };

  const handleCloseMapFullView = () => {
    setMobileFullView(false);
    window.parent.postMessage({ mobileFullView: "false" }, "*");
  };

  //get viewable markers and set viewable markers state
  const getViewableMarkers = () => {
    let currentBounds = mapRef.current.getBounds();

    //////////
    //VISIBLE LOCATIONS ARRAY
    setVisibleMarkers([]);
    var visibleMarkersArray = [];
    var visibleMarkersLoaded = 0;

    //add current viewable markers
    markerMap.map(marker => {
      if (currentBounds.contains(marker[0].getPosition()) === true) {
        //check if statewide so it will not repeat in statewide array
        if (marker[1].StateWide !== true) {
          visibleMarkersArray.push([marker[0], marker[1]]);
        }
      }
      visibleMarkersLoaded++;
      if (visibleMarkersLoaded === dataLength) {
        setVisibleMarkers(visibleMarkersArray);
      }
    }, []);
    ////////////////////////////

    //////get id's of visible items to check for repeats
    var currentVisibleMarkersIDs = [];
    visibleMarkersArray.map(marker => {
      currentVisibleMarkersIDs.push(marker[1].ID);
    });

    /////////
    //NATIONAL LOCATIONS ARRAY
    setNationalMarkers([]);
    var nationalMarkersArray = [];

    markerMap.map(marker => {
      if (marker[1].Type === "National") {
        nationalMarkersArray.push([marker[0], marker[1]]);
      }
    }, []);
    /////////////////////

    //filter repeats for National locations
    var noRepeatsNationalMarkersArray = [];
    noRepeatsNationalMarkersArray = nationalMarkersArray.filter(item => {
      return currentVisibleMarkersIDs.indexOf(item[1].ID) == -1;
    });

    setNationalMarkers(noRepeatsNationalMarkersArray);
  };

  useEffect(() => {
    if (markerMap.length != 0 && initLoad === true) {
      //pass loaded state to 2nd search box
      if (isLoaded) {
        //console.log("libraries loaded");
        setPlaces(libraries);
      }

      //NATIONAL LOCATIONS ARRAY
      setNationalMarkers([]);
      var nationalMarkersArray = [];

      markerMap.map(marker => {
        if (marker[1].Type === "National") {
          nationalMarkersArray.push([marker[0], marker[1]]);
        }
      }, []);
      setNationalMarkers(nationalMarkersArray);
      /////////////////////

      setSelectedMarker(0, false);

      //pass markers to root
      passMarkerData(markerMap);
      setInitLoad(false);

      getCurrentLocation();

      if (currentView.initialView === true) {
        updateCurrentView("initialView");
      }

      ///after Initial load set resize flag for parent site that is hosting this app in iframe
      let root = document.getElementById("root");

      resizeObserver.observe(root);
    }
  }, [markerMap]);

  useEffect(() => {
    passNationalMarkers(nationalMarkers);

    //gets out of initial map state
    if (currentView.initialView !== true) {
      //if (currentView.initialView !== true && !mobileView) {
      updateCurrentView("searchView");
    }
  }, [nationalMarkers]);

  useEffect(() => {
    passVisibleMarkers(visibleMarkers);

    //gets out of initial map state
    if (currentView.initialView !== true) {
      //if (currentView.initialView !== true && !mobileView) {
      updateCurrentView("searchView");
    }
  }, [visibleMarkers]);

  useEffect(() => {
    if (currentView.modalView === true) {
      //console.log("modalView");
      setTimeout(function() {
        //window.parent.postMessage({ mobileOverlayView: "true" }, "*");
        window.parent.postMessage({ height: "600" }, "*");
        //console.log("set height 600");
      }, 200);
    }
  }, [currentView]);

  if (loadError) return "Error";
  if (!isLoaded) return "Loading...";

  return (
    <div className={"mapModule"}>
      {mobileFullView ? (
        <button
          className={"exitMapBtn"}
          onClick={() => handleCloseMapFullView()}
        >
          EXIT MAP VIEW
        </button>
      ) : null}
      {mapRef.current ? (
        <div className={"mapSearchField"}>
          <SearchField mapRef={mapRef} onSearchSubmit={handleSearchSubmit} />
        </div>
      ) : null}

      <div className={"mapControls"}>
        <Locate onLocationUpdate={getCurrentLocation} />
        <BlueToolTip title="ZOOM IN" placement="right" arrow>
          <button
            onClick={() => {
              handleZoomOut();
            }}
          >
            <img alt="Plus sign icon" src={zoomIn} />
          </button>
        </BlueToolTip>
        <BlueToolTip title="ZOOM OUT" placement="right" arrow>
          <button
            onClick={() => {
              handleZoomIn();
            }}
          >
            <img alt="Minus sign icon" src={zoomOut} />
          </button>
        </BlueToolTip>
      </div>

      <GoogleMap
        id="map"
        zoom={mapZoom}
        center={mapCenter}
        options={options}
        onLoad={onMapLoad}
      >
        {currentLocation ? (
          <Marker
            key="currentLocation"
            position={{
              lat: currentLocation.lat,
              lng: currentLocation.lng
            }}
            icon={{
              url: mapPinCurrent,
              scaledSize: new window.google.maps.Size(43, 55)
            }}
          ></Marker>
        ) : null}
        {locationData.locations.map((location, index) => {
          return (
            <MapMarker
              key={index}
              location={location}
              initLoad={initLoad}
              markerLoadHandler={markerLoadHandler}
              markerClickUpdate={markerClickHandler}
              selectedResult={selectedResult}
              togglePinsOff={togglePinsOff}
            />
          );
        })}
      </GoogleMap>
    </div>
  );
};

export default Map;
